import { createSlice } from '@reduxjs/toolkit';

const initialState = { ids: {}, pathSegments: [], pathParams: [] };

const paramsSlice = createSlice({
  name: 'params',
  initialState,
  reducers: {
    setParams(state, action) {
      // Preserve only non-path ids that are intentionally URL-independent.
      // Keeping all previous ids causes stale path params (e.g. roomId/assetId)
      // to leak across routes after back/refresh navigation.
      const incomingIds = action.payload?.ids || {};
      const persistedIds = {};

      if (!Object.prototype.hasOwnProperty.call(incomingIds, 'floor')) {
        persistedIds.floor = state.ids.floor;
      }

      return {
        ...action.payload,
        ids: { ...incomingIds, ...persistedIds },
      };
    },
    setParamId(state, action) {
      state.ids[action.payload.id] = action.payload.value;
      return state;
    },
  },
});

export default paramsSlice.reducer;

export const { setParams, setParamId } = paramsSlice.actions;
